import Repository from './Repository'
import TokenService from '../helpers/token'

const resource = `${Repository.defaults.baseURL}/allotment`

export default {
  async listAllotment(params) {
    const response = await Repository.get(`${resource}`, {
      params,
      headers: TokenService.getHeader(),
    })
    return response
  },
  async update(id, allotment) {
    const response = await Repository.patch(`${resource}/${id}`, allotment, {
      headers: TokenService.getHeader(),
    })
    return response
  },
  async create(params) {
    const response = await Repository.post(`${resource}`, params, {
      headers: TokenService.getHeader(),
    })
    return response
  },
  async delete(id) {
    const response = await Repository.delete(`${resource}/${id}`, {
      headers: TokenService.getHeader(),
    })
    return response
  },
  async listUserAllotment(params) {
    const response = await Repository.get(`${resource}-user`, {
      params,
      headers: TokenService.getHeader(),
    })
    return response
  },
  async updateIndexAllotmentUser(params) {
    const response = await Repository.post(`${resource}-user/source`, params, {
      headers: TokenService.getHeader(),
    })
    return response
  },
  async changeAllotmentUser(body) {
    const response = await Repository.post(`${resource}-user/rule`, body, {
      headers: TokenService.getHeader(),
    })
    return response
  },
  async onOffAllotmentUser(body) {
    const response = await Repository.post(`${resource}-user/active`, body, {
      headers: TokenService.getHeader(),
    })
    return response
  },
}
